import Breadcrumbs from '@feature/Breadcrumbs'
import PageContainer from '@feature/PageContainer'
import Space from '@feature/Space'
import { Stack, Typography } from '@mui/material'
import { cssFluidSize } from 'theme/styleHelpers'
import { colors } from 'theme/themePalette'

const Header = () => (
  <Stack
    bgcolor={colors.offWhite}
    minHeight={cssFluidSize([110, 375])}
    alignItems={'center'}
    justifyContent={'flex-end'}
  >
    <PageContainer>
      <Typography variant="h1" mb={'1em'} mt={'2em'}>
        Product Finder
      </Typography>
      {/* <Space y='md'/> */}

      <Breadcrumbs />
      <Space y="sm" />
    </PageContainer>
  </Stack>
)

export default Header
